import { createFileRoute } from '@tanstack/react-router';
import { CountriesPage } from '@/components/countries/countries-page';

export const Route = createFileRoute('/_app/countries')({
  component: CountriesPage,
});
